// Preprocess GitBook-flavored markdown into plain markdown + HTML blocks that
// react-markdown (with rehype-raw) can render. We keep the transformations
// minimal and predictable so markdown inside the transformed blocks still
// renders as markdown.

export function preprocessGitBook(md) {
  if (!md) return "";

  let out = md;

  // {% hint style="info" %} ... {% endhint %}
  out = out.replace(
    /\{%\s*hint\s+style="(\w+)"\s*%\}([\s\S]*?)\{%\s*endhint\s*%\}/g,
    (_, style, content) => {
      return `\n\n<div data-doc="hint" data-style="${style}">\n\n${content.trim()}\n\n</div>\n\n`;
    }
  );

  // {% tabs %} ... {% tab title="X" %} ... {% endtab %} ... {% endtabs %}
  // We wrap the whole group in a container and each tab in its own div so
  // the custom component can walk children at render time.
  out = out.replace(
    /\{%\s*tabs\s*%\}([\s\S]*?)\{%\s*endtabs\s*%\}/g,
    (_, inner) => {
      const transformed = inner.replace(
        /\{%\s*tab\s+title="([^"]+)"\s*%\}([\s\S]*?)\{%\s*endtab\s*%\}/g,
        (__, title, body) => {
          return `\n\n<div data-doc="tab" data-title="${escapeAttr(title)}">\n\n${body.trim()}\n\n</div>\n\n`;
        }
      );
      return `\n\n<div data-doc="tabs">\n\n${transformed.trim()}\n\n</div>\n\n`;
    }
  );

  return out;
}

function escapeAttr(s) {
  return String(s)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}
